export const bookingStatuses = [
  {
    name: 'Booking requested',
    id: 1,
  },
  {
    name: 'Booking confirmed',
    id: 2,
  },
  {
    name: 'Work done',
    id: 3,
  },
  {
    name: 'Claim submitted',
    id: 4,
  },
  {
    name: 'Claim authorised',
    id: 5,
  },
  {
    name: 'Claim paid',
    id: 6,
  },
];

export const bookingTabs = [
  {
    name: 'All',
    id: [1, 2, 3, 4, 5, 6],
  },
  ...bookingStatuses,
];
